<template>
  <span
    draggable="true"
    :style="{ display: 'inline-block', cursor: 'pointer' }"
    @click="click($event)"
    :data-value="value"
    @dragstart="dragStart($event)"
  >
    <v-chip>{{ label }}</v-chip>
  </span>
</template>

<script>
export default {
  name: 'DraggableChip',
  props: {
    value: String,
    label: String
  },
  methods: {
    dragStart(event) {
      event.dataTransfer.setData('Text', event.target.dataset.value)
    },
    click(event) {
      this.$emit('onClick', event.target.dataset.value)
    }
  }
}
</script>

<style scoped>
span {
  display: inline-block;
}
</style>
